@if (icon) {
    <div class="media" [ngStyle]="{'height.px': height, 'width.px': width}">
        <svg class="media-object" xmlns="http://www.w3.org/2000/svg" [ngStyle]="color ? {'fill': color} : {}">
            <use [attr.xlink:href]="'#' + icon"></use>
        </svg>
    </div>
}
